import React from "react";
import {
  ElementsConsumer,
  CardElement,
  CardNumberElement,
  Elements,
} from "@stripe/react-stripe-js";
import { Link } from "react-router-dom";
import CardSection from "./CardSection";
import { ToastContainer, toast } from "react-toastify";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import swal from "sweetalert";

class CheckoutSection extends React.Component {
  handleSubmit = async (event) => {

    event.preventDefault();
    const {shippingInfo} = this.props;

    let pickupMiles = 0;
    const hasHighLocalPickup =  false

    if (hasHighLocalPickup) {
      swal({
        title: `Local Pickup Warning`,
        text: "This item is far for pickup, please choose shipping option.",
        // text: `One of your items is ${pickupMiles} miles from you. Are you sure you will travel that distance to pick up the item?   `,
        icon: "error",
        buttons: {
          confirm: {
            text: "Yes, I am Sure",
            value: true,
            visible: true,
            className: "swal-btn-cancel",
          },
          cancel: {
            text: "No, I will choose a shipping method",
            value: false,
            visible: true,
            className: "swal-btn-confirm"
          }
        },
        dangerMode: true,
      }).then(async (willReactive) => {
        try {
          // console.log(willReactive);
          if (willReactive) {
            const errorKeys = Object.keys(this.props.errors);
            //console.log(errorKeys)
            if (errorKeys.length === 0) {
              this.props.setSpinner(true);
              const toastOption = {
                position: "top-right",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              };

              const { stripe, elements } = this.props;
              if (!stripe || !elements) {
                return;
              }

              const card = elements.getElement(CardNumberElement);
              const result = await stripe.createToken(card);
              if (result.error) {
                toast.error(result.error.message, toastOption);
                //console.log(result.error.message);
                this.props.setSpinner(false);
              } else {
                //console.log(result.token);
                this.props.setId(result.token);
                this.props.submitForm();
                return;
              }
            } else {
              document.getElementsByName(errorKeys[0])[0].focus();
            }
          } else {
            return;
          }
        } catch (error) {
          console.log(error);
        }
      });
    } else {
      const errorKeys = Object.keys(this.props.errors);
      //console.log(errorKeys)
      if (errorKeys.length === 0) {
        this.props.setSpinner(true);
        const toastOption = {
          position: "top-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        };

        const { stripe, elements } = this.props;
        if (!stripe || !elements) {
          return;
        }

        const card = elements.getElement(CardNumberElement);
        const result = await stripe.createToken(card);
        if (result.error) {
          toast.error(result.error.message, toastOption);
          //console.log(result.error.message);
          this.props.setSpinner(false);
        } else {
          //console.log(result.token);
          this.props.setId(result.token);
          this.props.submitForm();
          return;
        }
      } else {
        document.getElementsByName(errorKeys[0])[0].focus();
      }
    }
  };

  render() {
    const { shippingInfo } = this.props;
    return (
      <div>
        <form>
          <CardSection />
          <button
            style={{
              margin: "20px 0px",
              fontWeight: "bold",
              fontFamily: "LATO",
              fontSize: "16px",
            }}
            type="button"
            onClick={this.handleSubmit}
            title={
              this.props.addressDone === false
                ? "Please Update Address First"
                : ""
            }
            className={`btn dark-btn ${
              this.props.addressDone === false ? "dis-btn" : ""
            }`}
            disabled={
              !this.props.stripe ||
              this.props.spinner === true ||
              !this.props.addressDone
            }
          >
            {!this.props.stripe || this.props.spinner === true
              ? "Please Wait"
              : "Submit Order"}
          </button>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  shippingStatus: state.shippingprice.shippingStatus,
  shippingInfo: state.shippingprice.shippingInfo,
  shippingError: state.shippingprice.shippingError,
  salesTax: state.shippingprice.salesTax,
});


export default connect(mapStateToProps)(function InjectedCheckoutSection({
  submitForm,
  formRef,
  setId,
  spinner,
  setSpinner,
  errors,
  addressDone,
  shippingInfo
}) {
  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <CheckoutSection
          stripe={stripe}
          elements={elements}
          submitForm={submitForm}
          formRef={formRef}
          setId={setId}
          spinner={spinner}
          setSpinner={setSpinner}
          errors={errors}
          addressDone={addressDone}
          shippingInfo={shippingInfo}
        />
      )}
    </ElementsConsumer>
  );
})
